import {
  ChatEscalationCreateData,
  ChatEscalationInterface,
  EscalationRepositoryInterface, TicketEscalationCreateData, TicketEscalationInterface,
} from '@/services/QC-V2/escalation/interfaces';
import { AxiosInstance } from 'axios';
import { FilterRequestData, ChatReviewFormDataInterface, ChatReviewInterface } from '@/services/QC-V2/chat/interfaces';
import { EscalationStatus } from '@/services/QA/escalation';
import { TicketReviewFormDataInterface, TicketReviewInterface } from '@/services/QC-V2/ticket/interfaces';

export default class EscalationRepository implements EscalationRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createChatEscalation(
    escalation: ChatEscalationCreateData,
    reviews?: ChatReviewFormDataInterface[],
  ): Promise<void> {
    await this.axios.post('/chat-controller-v2/escalations', { escalation, reviews });
  }

  public async createTicketEscalation(
    escalation: TicketEscalationCreateData,
    reviews?: TicketReviewFormDataInterface[],
  ): Promise<void> {
    await this.axios.post('/ticket-controller-v2/escalations', { escalation, reviews });
  }

  public async findAllChatEscalations(
    filterRequestData?: FilterRequestData,
  ): Promise<[ChatEscalationInterface[], number]> {
    let url = '/chat-controller-v2/escalations?';
    if (filterRequestData) {
      const parameters = Object.keys(filterRequestData)
        .filter((key) => !key.startsWith('ticket') && !!filterRequestData[key])
        .map((key) => `${key}=${filterRequestData[key]}`);

      url = `${url}${parameters.join('&')}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async findAllTicketEscalations(
    filterRequestData?: FilterRequestData,
  ): Promise<[TicketEscalationInterface[], number]> {
    let url = '/ticket-controller-v2/escalations?';
    if (filterRequestData) {
      const parameters = Object.keys(filterRequestData)
        .filter((key) => !key.startsWith('chat') && !!filterRequestData[key])
        .map((key) => `${key}=${filterRequestData[key]}`);

      url = `${url}${parameters.join('&')}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async findChatEscalationById(id: number): Promise<ChatEscalationInterface> {
    const response = await this.axios.get(`chat-controller-v2/escalations/${id}`);

    return response.data;
  }

  public async findTicketEscalationById(id: number): Promise<TicketEscalationInterface> {
    const response = await this.axios.get(`ticket-controller-v2/escalations/${id}`);

    return response.data;
  }

  public async changeEscalationStatus(id: number, status: EscalationStatus): Promise<void> {
    await this.axios.patch(`/chat-controller-v2/escalations/${id}/status`, { status });
  }

  public async reviewChatEscalation(
    id: number,
    reviews?: ChatReviewFormDataInterface[],
  ): Promise<void> {
    const response = await this.axios.patch(`/chat-controller-v2/escalations/${id}/reviews`, { reviews });

    return response.data;
  }

  public async reviewTicketEscalation(
    id: number,
    reviews?: TicketReviewFormDataInterface[],
  ): Promise<void> {
    const response = await this.axios.patch(`/ticket-controller-v2/escalations/${id}/reviews`, { reviews });

    return response.data;
  }
}
